import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MapPin } from "lucide-react";
import type { TranslateFn } from "@/types";

interface LocationFieldsProps {
  hotelName: string;
  roomNumber: string;
  onChange: (field: string, value: string) => void;
  t: TranslateFn;
}

export const LocationFields = ({ hotelName, roomNumber, onChange, t }: LocationFieldsProps) => (
  <div className="space-y-4">
    <h3 className="font-semibold text-lg flex items-center gap-2">
      <MapPin className="h-5 w-5" />
      {t('booking.location')}
    </h3>
    <div className="grid grid-cols-2 gap-4">
      <div>
        <Label htmlFor="hotel_name">{t('booking.hotelName')} *</Label>
        <Input
          id="hotel_name"
          data-testid="input-hotel-name"
          value={hotelName}
          onChange={(e) => onChange("hotel_name", e.target.value)}
          placeholder={t('booking.hotelPlaceholder')}
          required
        />
      </div>
      <div>
        <Label htmlFor="room_number">{t('booking.roomNumber')} *</Label>
        <Input
          id="room_number"
          data-testid="input-room-number"
          value={roomNumber}
          onChange={(e) => onChange("room_number", e.target.value)}
          placeholder={t('booking.roomPlaceholder')}
          required
        />
      </div>
    </div>
  </div>
);
